import React from 'react';
import PropTypes from 'prop-types';
import MicIcon from '@mui/icons-material/Mic';
import { Box, Table, TableBody, TableRow, TableCell, Typography, Button } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import AdvisorDashboardTile from './AdvisorDashboardTile';
// import { useGetAppConfigQuery } from 'app/api/mainApi';

const AdvisorEnhanceYourBusiness = ({ setAccordion, setDrawerOpen }) => {
  const onViewMoreClick = () => {
    setAccordion('enhance');
    setDrawerOpen(true);
  };

  return (
    <AdvisorDashboardTile
      title="Enhance Your Business"
      icon={<AutoFixHighIcon sx={{ color: '#888' }} />}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <img src="/plus_frontend/assets/svg/ico-goodies2.svg" alt="Goodies" className="nav-icon" style={{ filter: 'grayscale(100%) invert(70%)' }} />
              </TableCell>
              <TableCell>
                <Typography variant="h6" component="div">
                  Goody Bags
                </Typography>
                <Typography variant="body2">
                  Sell your digital content.
                </Typography>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  href="/account/filemanager?modal=createGoodyBag#tab-goody"
                  sx={{ color: 'white !important', textDecoration: 'none' }}
                >
                  Create
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <MicIcon sx={{ color: '#888' }} />
              </TableCell>
              <TableCell>
                <Typography variant="h6" component="div">
                  Recorded Listings
                </Typography>
                <Typography variant="body2">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </Typography>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  href="/listings/choose_topic/839?listing_type=2"
                  sx={{ color: 'white !important', textDecoration: 'none' }}
                >
                  Create
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>

      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <button type="button" onClick={onViewMoreClick} style={{ textDecoration: 'none', background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>
          View more
        </button>
      </Box>
    </AdvisorDashboardTile>
  );
};

AdvisorEnhanceYourBusiness.propTypes = {
  setDrawerOpen: PropTypes.func.isRequired,
  setAccordion: PropTypes.func.isRequired,
};

export default AdvisorEnhanceYourBusiness;
